var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.preview
  }, [_c('base-icon', {
    directives: [{
      name: "p-t",
      rawName: "v-p-t",
      value: 4,
      expression: "4"
    }, {
      name: "color",
      rawName: "v-color:black-2",
      arg: "black-2"
    }],
    attrs: {
      "name": "basic_list"
    }
  })], 1), _c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 10,
      expression: "10"
    }],
    class: _vm.$style.title,
    domProps: {
      "textContent": _vm._s(_vm.$t('bill.description'))
    }
  }), _vm.splitedDescription ? _c('div', {
    class: _vm.$style.description
  }, _vm._l(_vm.splitedDescription, function (description, idx) {
    return _c('p', {
      key: idx,
      domProps: {
        "textContent": _vm._s(description)
      }
    });
  }), 0) : _vm._e(), _vm.isShownTildaParams ? [_c('div', {
    directives: [{
      name: "m-t",
      rawName: "v-m-t",
      value: 10,
      expression: "10"
    }],
    class: _vm.$style.description
  }, _vm._l(_vm.tildaCustomFields, function (value, name) {
    return _c('p', {
      key: name,
      domProps: {
        "textContent": _vm._s("".concat(name, " - ").concat(value))
      }
    });
  }), 0), _c('div', {
    directives: [{
      name: "m-t",
      rawName: "v-m-t",
      value: 10,
      expression: "10"
    }],
    class: _vm.$style.description
  }, _vm._l(_vm.tildaProducts, function (value, idx) {
    return _c('p', {
      key: idx,
      domProps: {
        "textContent": _vm._s(value)
      }
    });
  }), 0), _vm.tildaAddationalString ? _c('div', {
    directives: [{
      name: "m-t",
      rawName: "v-m-t",
      value: 10,
      expression: "10"
    }],
    class: _vm.$style.description,
    domProps: {
      "textContent": _vm._s(_vm.tildaAddationalString)
    }
  }) : _vm._e()] : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }